export default __webpack_public_path__ + "static/client7-09309137064507b8185ccc0c10bb4978.svg";